import { Link, usePage } from '@inertiajs/react'
import { ChartNoAxesCombined } from 'lucide-react'
import type { SharedProps } from '@/frontend/types/inertia'

export default function SidebarLink({ onNavigate, compact = false }: { onNavigate: () => void; compact?: boolean }) {
  const { url, props } = usePage<SharedProps>()
  const path = url.split('?')[0]
  // A dashboard URL carries the project explicitly; never fall back to another
  // project's default while navigating its publication or returning to Forge.
  const dashboardProjectId = path.match(/^\/dashboard\/projects\/([^/]+)\/dashboards(?:\/|$)/)?.[1]
  const projectId = dashboardProjectId || new URLSearchParams(url.split('?')[1] ?? '').get('project_id') || props.forgeAccess?.default_project_id
  if (!projectId) return null
  const active = !!dashboardProjectId
  const label = props.navigationLabels.dashboards
  return <Link href={`/dashboard/projects/${encodeURIComponent(projectId)}/dashboards`} onClick={onNavigate} aria-current={active ? 'page' : undefined}
    title={compact ? label : undefined} aria-label={label}
    className={`flex items-center gap-2 rounded-lg px-2.5 py-1.5 text-[12.5px] font-medium transition-colors ${compact ? 'justify-center' : ''} ${
      active ? 'bg-accent text-foreground' : 'text-muted-foreground hover:bg-accent/70 hover:text-foreground'
    }`}>
    <ChartNoAxesCombined className="size-3.5 flex-shrink-0" strokeWidth={1.75} />
    {!compact && <span>{label}</span>}
  </Link>
}
